import { c as _c } from "react/compiler-runtime";
import { VillaSearchSummaryContent } from "@website/accommodation-ui/villa-search/villa-search-summary/villa-search-summary-content/villa-search-summary-content";
import { useVillaSearchSummary } from "@website/accommodation-ui/villa-search/villa-search-summary/villa-search-summary.hook";
import { VillaSearchSummaryPropertiesType } from "@website/accommodation-ui/villa-search/villa-search-summary/villa-search-summary.types";
import { FC } from "react";
export const VillaSearchSummary: FC<VillaSearchSummaryPropertiesType> = properties => {
  const $ = _c(2);
  const viewProperties = useVillaSearchSummary(properties);
  let t0;
  if ($[0] !== viewProperties) {
    t0 = <VillaSearchSummaryContent {...viewProperties} />;
    $[0] = viewProperties;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};